"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montopoli-in-val-d-arno": {
    "1a1d23c4": [{
      "hkey": "1cb42a82",
      "slug": "castel-del-bosco",
      "name": "Castel del Bosco",
      "primary": true,
      "skipSearch": false
    }],
    "casteldelbosco": [{
      "hkey": "1cb42a82",
      "slug": "castel-del-bosco",
      "name": "Castel del Bosco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;